const minin = {
  data() {
    return {
      formCtrl: [
        {
          label: "订单编号",
          keyName: "order_num",
          err: "请填写订单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        // {
        //   label: "货物名称",
        //   keyName: "name",
        //   err: "请填写货物名称",
        //   type: "text",
        //   viewMode: true,
        // },
      ],
      formCtrlOrder0: [],
      formCtrlOrder01: [],
      formCtrlOrder: [
        {
          label: "加油方式",
          keyName: "gasname",
          err: "请选择加油方式",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "现金加油（元）",
          keyName: "doil",
          err: "请填写现金加油",
          type: "number",
          viewMode: true,
        },
        {
          label: "非现金加油（元）",
          keyName: "moneydoil",
          err: "请填写油气费",
          type: "number",
          viewMode: true,
        },
        {
          label: "现金票据",
          keyName: "moneyphoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "非现金票据",
          keyName: "photo",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "开始里程数",
          keyName: "ksmileage",
          err: "请填写开始里程数",
          type: "number",
          viewMode: true,
        },
        {
          label: "结束里程数",
          keyName: "jsmileage",
          err: "请填写结束里程数",
          type: "number",
          viewMode: true,
        },
        {
          label: "开始里程单据",
          keyName: "ksmileagephoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "结束里程单据",
          keyName: "jsmileagephoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
      ],
      formCtrlOrder2: [
        {
          label: "加油方式",
          keyName: "gasname2",
          err: "请选择加油方式",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "非现金加油（元）",
          keyName: "moneydoil_second",
          err: "请填写油气费",
          type: "number",
          viewMode: true,
        },
        {
          label: "非现金票据",
          keyName: "photo_second",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
      ],
      formCtrlOrder3: [
        {
          label: "加油方式",
          keyName: "gasname3",
          err: "请选择加油方式",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "非现金加油（元）",
          keyName: "moneydoil_third",
          err: "请填写油气费",
          type: "number",
          viewMode: true,
        },
        {
          label: "非现金票据",
          keyName: "photo_third",
          className: "unton",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
      ],
      formCtrl2: [
        {
          label: "出车费用票据",
          keyName: "cost_images",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          type: "textarea",
          viewMode: true,
          className: "block",
          rows: 4,
        },
        {
          label: "合计",
          keyName: "total",
          type: "number",
          viewMode: true,
          className: "block",
        },
        {
          label: "司机填写",
          keyName: "isover",
          type: "select",
          viewMode: true,
          className: "block",
          options: [
            { label: '未完成', value: 1 },
            { label: '已完成', value: 2 },
          ],
        },
      ],
      getDataUrl: 'money',
      submitUrl: 'examinemoney',
      dayauth: [],
      // 里程单位价格
      unitprice: 0,
      order: {},
      rejectCtrl: {
        label: "驳回原因",
        keyName: "reject_reason",
        type: "textarea",
        viewMode: true,
        className: "block",
        rows: 4,
      },
      // 是否已审核
      checked: false,
    };
  },
  computed: {
    // 是否显示驳回按钮
    showRejectBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      // console.log(this.order.isstatus != 3 || this.order.isover != 2, boo)
      if (this.order.isstatus != 3 || this.order.isover != 2) return boo
      if (this.user && this.detail.isfleet != 2) {
        if ([5].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
    // 是否显示审核按钮
    showExamineBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      const { isstatus, isover } = this.order
      // console.log(isstatus != 3 || isover != 2, boo)
      if (isstatus != 3 || isover != 2) return boo
      const { isfleet, is_manager } = this.detail
      if (this.user && isfleet == 2) {
        if ([1].includes(this.user.user_group_id)) {
          boo = true
        }
      } else {
        if ([5].includes(this.user.user_group_id) && is_manager == 1) {
          boo = true
        }
      }
      return boo
    },
  },
  methods: {
    paramsPackage(params, object) {
      // console.log({ ...params })
      // console.log({ ...object })
      // params = { ...params, ...newform }
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && !['driver', 'shname', 'isstatus', 'is_reject', 'reject_reason', 'userid'].includes(key)) {
          // console.log(typeof object[key])
          const value = object[key]
          if (value && typeof value === 'object') {
            // console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else if (['moneydoil_second', 'moneydoil_third'].includes(key)) {
            params[key] = value || 0
          } else {
            params[key] = value;
          }
        }
      }

      // const { isfleet } = params

      // console.log('isfleet', isfleet)

      // const mod = this.$route.path.includes('/nocontract') ? 'order' : 'contract_order'
      params['headers'] = {
        'X-Method': 'update',
        'X-Module': 'trip_expense',
      }

      // console.log('params', { ...params })

      // 已完成订单二次编辑费用
      // if (object['isstatus'] == 4) {
      //   params['type'] = 2
      // }
    },

    onCheckSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs['form'].validate((valid) => {
        const boo = this.formOrtherValidate()
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm('确认审核通过吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(this.checkSubmitReq).catch(() => { });
        } else {
          console.log('验证不通过');
          return false;
        }
      });
    },
    checkSubmitReq() {
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      
      // 车队长审核费用
      params['isfleet'] = 2

      // console.log('isfleet', params.isfleet)

      // const mod = this.$route.path.includes('/nocontract') ? 'order' : 'contract_order'
      params['headers'] = {
        'X-Method': 'review',
        'X-Module': 'trip_expense',
      }

      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
        this.loading = false
      })
    },

    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      // 所有配置费用项
      const arr = []
      this.dayauth.map(v => {
        // console.log(v.enname, v.id)
        if (v.id != 1) {
          arr.push(v.enname)
        }
      })
      // 加上油气费
      const arr1 = [...arr, 'doil', 'moneydoil', 'moneydoil_second', 'moneydoil_third', 'unitotal', 'jsmileage', 'ksmileage']
      // console.log(arr1)
      if (value && typeof value === 'object') {
        // 图片
        if (value.length) {
          this.form[key] = value.map(v => {
            let result = v
            if (v.response && v.response.photo) {
              result = { url: v.response.photo }
            }
            return result
          })
        } else {
          this.form[key] = null
        }
      } else if (arr1.includes(key)) {
        // 合计
        this.form[key] = value;
        // 实时计算总额
        this.$nextTick(() => {
          let dtotal = 0
          const object = { ...this.form }
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key) && (key.includes('isnum') || ['commission', 'meal', 'stay'].includes(key))) {
              const element = object[key];
              // console.log(element)
              this.dayauth.map(v => {
                if (key === v.enname && v.isnum != 2) {
                  dtotal += Number(element)
                }
              })
            }
          }
          const { doil, moneydoil, moneydoil_second, moneydoil_third, jsmileage, ksmileage } = this.form
          if (this.form.jsmileage != 0) {
            dtotal += Number(doil) + Number(moneydoil) + Number(moneydoil_second) + Number(moneydoil_third) + (Number(jsmileage) - Number(ksmileage)) * this.unitprice
          } else {
            dtotal += Number(doil) + Number(moneydoil) + Number(moneydoil_second) + Number(moneydoil_third)
          }
          console.log('total', dtotal)
          this.form.total = dtotal.toFixed(2)
          this.$forceUpdate()
        })
      } else if (key == 'gasname') {
        this.form[key] = value;
        this.formCtrlOrder.map(c => {
          if (c.label == '加油方式') {
            c.options.map(o => {
              if (o.value == value) {
                this.form['gsid'] = o.id;
              }
            })
          }
        })
      } else if (key == 'gasname2') {
        this.form[key] = value;
        this.formCtrlOrder2.map(c => {
          if (c.label == '加油方式') {
            c.options.map(o => {
              if (o.value == value) {
                this.form['gsid_second'] = o.id;
              }
            })
          }
        })
      } else if (key == 'gasname3') {
        this.form[key] = value;
        this.formCtrlOrder3.map(c => {
          if (c.label == '加油方式') {
            c.options.map(o => {
              if (o.value == value) {
                this.form['gsid_third'] = o.id;
              }
            })
          }
        })
      } else {
        this.form[key] = value;
      }

      this.$nextTick(() => {
        this.setOilOptions(key, value)
      })

      console.log('form', { ...this.form });
    },

    setOilOptions(key) {
      // console.log(key)
      const { gasname, gasname2, gasname3 } = this.form
      // console.log('gasname', gasname)
      // console.log('gasname2', gasname2)
      // console.log('gasname3', gasname3)
      if (key === 'gasname') {
        this.formCtrlOrder2.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              c.disabled = false
              if ([gasname, gasname3].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              }
            })
          }
        })

        this.formCtrlOrder3.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              c.disabled = false
              if ([gasname, gasname2].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              }
            })
          }
        })
        
      } else if (key === 'gasname2') {
        this.formCtrlOrder.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              c.disabled = false
              if ([gasname2, gasname3].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              }
            })
          }
        })

        this.formCtrlOrder3.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              c.disabled = false
              if ([gasname, gasname2].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              }
            })
          }
        })
        
      } else if (key === 'gasname3') {
        this.formCtrlOrder.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              if ([gasname2, gasname3].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              } else {
                c.disabled = false
              }
            })
          }
        })

        this.formCtrlOrder2.map((v) => {
          if (v.label == '加油方式') {
            v.options.map((c) => {
              if ([gasname, gasname3].includes(c.label) && c.label != '无' && c.label != '未加油') {
                c.disabled = true
              } else {
                c.disabled = false
              }
            })
          }
        })
        
      }
    },

    setDetail() {
      const {
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      } = this.order
      this.form = {
        ...this.detail,
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      }
      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    setDetailOrderData({ dayauth, gasstation, unitprice, data, order }) {
      const { isover, gasname, gasname2, gasname3 } = data
      this.order = { ...order, isover }
      // console.log('showExamineBtn', this.showExamineBtn)
      // 出车费用汇总详情提交接口
      if (!this.showExamineBtn && [1, 2, 3, 4].includes(this.user.user_group_id)) {
        this.submitUrl = 'archivesmoney'
      }
      // 里程单位价格
      this.unitprice = unitprice
      this.dayauth = dayauth
      const { user_group_id } = this.user
      dayauth.map(v => {
        const key = v.enname
        if (Object.hasOwnProperty.call(this.detail, key)) {
          let label = v.authname + '(元)'
          if (v.authname === '加油量') {
            label = v.authname + '(升)'
            this.formCtrlOrder0.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
            })
          } else if (['司机提成', '用餐补贴', '住宿补贴'].includes(v.authname)) {
            this.formCtrlOrder01.push({
              label,
              keyName: key,
              type: "text",
              viewMode: user_group_id == 1 && (order.isstatus == 4) ? false : true,
            })
          } else {
            this.formCtrlOrder.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
            })
          }
        }
      })
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'gasname' && gasstation.length) {
          c.options = gasstation.map(v => {
            return {
              label: v.gasname,
              value: v.gasname,
              id: v.id,
              disabled: [gasname2, gasname3].includes(v.gasname)
            }
          })
          // console.log(c.options)
        }
      })
      this.formCtrlOrder2.map(c => {
        if (c.label == '加油方式' && gasstation.length) {
          gasstation.map(v => {
            if (!['油卡加油', '现金加油', '其他'].includes(v.gasname)) {
              c.options.push({
                label: v.gasname,
                value: v.gasname,
                id: v.id,
                disabled: [gasname, gasname3].includes(v.gasname)
              })
            }
          })
          // console.log(c.options)
        }
      })
      this.formCtrlOrder3.map(c => {
        if (c.label == '加油方式' && gasstation.length) {
          gasstation.map(v => {
            if (!['油卡加油', '现金加油', '其他'].includes(v.gasname)) {
              c.options.push({
                label: v.gasname,
                value: v.gasname,
                id: v.id,
                disabled: [gasname, gasname2].includes(v.gasname),
              })
            }
          })
          // console.log(c.options)
        }
      })
      // console.log('form', { ...this.form })
      this.$forceUpdate()
      // console.log([...this.formCtrlOrder])
    },
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt('', '驳回事由', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.rejectReq(value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    rejectReq(reject_reason) {
      this.loading = true
      let url = `order/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason
      }

      // const mod = this.$route.path.includes('/nocontract') ? 'order' : 'contract_order'
      params['headers'] = {
        'X-Method': 'reject',
        'X-Module': 'trip_expense',
      }
      // console.log('url', url)
      // console.log('params', { ...params })

      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '驳回成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '驳回失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.formCtrl2.slice(1)
  },
  mounted() {
    if (this.user.user_group_id == 1) {
      this.submitUrl = 'managerok'
    }
  },
}

export default minin